import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('loading',{
  state: () => {
    return {
      loading: 0
    }
  },
  getters: {
    isLoading: state => state.loading
  },
  actions: {
    setLoading(status) {
      if (status) {
        this.loading++
      } else {
        this.loading--
      }
    }
  },
  strict: false,
})
